function AddformSubmit(form) {
  const data = new FormData(form);
  fetch("/cart/add.js", {
    method: "POST",
    body: data,
  })
    .then(function (response) {
      if (response.ok) {
        return response.text();
      } else {
        throw "Error en la llamada Ajax";
      }
    })
    .then(function (data) {
      ajaxCart.load();
      setTimeout(() => {
        upsell.install();
        sidecartGammification();
      }, 1000);
    })
    .catch(function (error) {
      console.error("Error:", error);
    });
}
function insertUpsell() {
  let sidecartUpsell = document.querySelector(".sidecart-upsell");
  let cloneUpsell = sidecartUpsell.cloneNode(true);

  let contentUpsell = document.querySelector(".cart-upsell");
  if (contentUpsell) {
    contentUpsell.append(cloneUpsell);
  }
}
function insertHeaderCart() {
  let sidecartHeader = document.querySelector(".sidecart-header");

  let cloneHeader1 = sidecartHeader.cloneNode(true);
  let cloneHeader2 = sidecartHeader.cloneNode(true);

  let contentHeader = document.querySelector(".header-cart");
  let contentHeaderMobile = document.querySelector(".header-cart-mobile");

  contentHeaderMobile.append(cloneHeader2);
  cloneHeader2.style.display = "flex";

  // para que no se repita el clon en el header
  if (contentHeader.children.length > 0) {
    return;
  }

  contentHeader.append(cloneHeader1);
  cloneHeader1.style.display = "flex";
}

function add_to_cart(id, quantity) {
  if (typeof quantity == "undefined") {
    quantity = 1;
  }
  let formData = {
    items: [
      {
        id: id,
        quantity: quantity,
      },
    ],
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      ajaxCart.load();
      setTimeout(() => {
        upsell.install();
        sidecartGammification();
      }, 1000);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
function select_option(option, select) {
  select.querySelectorAll("[data-value]").forEach(function (option) {
    option.classList.remove("selected");
  });
  option.classList.add("selected");
}
docReady(function () {
  /*Button for gemPages card product*/
  let buttons = document.querySelectorAll(".gf_add-to-cart");

  window.addEventListener("scroll", function (event) {
    if (event.target.activeElement.classList.contains("drawer")) {
      window.scrollTo(0, 0);
      event.target.activeElement.scrollTop = 0;
      event.target.activeElement.style.overflow = "hidden";
      event.target.activeElement.style.height = "100%";
    }
  });

  if (buttons) {
    buttons.forEach(function (button_) {
      button_.addEventListener("click", function (e) {
        e.preventDefault();
        let module = button_.parentElement;
        module.dataset.ajaxcart = "0";
        let form = module.closest(".AddToCartForm");
        let selectForm = form.querySelector("select.spb-productdescfont");

        if (selectForm) {
          selectForm.name = "";
          if (selectForm.value == "") {
            if (button_.classList.contains("gf_button-soldout")) {
              return;
            } else {
              AddformSubmit(form);
            }
          } else {
            if (button_.classList.contains("gf_button-soldout")) {
              return;
            } else {
              setTimeout(function () {
                AddformSubmit(form);
              }, 800);
            }
          }
        } else {
          if (button_.classList.contains("gf_button-soldout")) {
            return;
          } else {
            AddformSubmit(form);
          }
        }
      });
    });
  }

  let cardsProduct = document.querySelectorAll(".product-card");

  cardsProduct.forEach(function (card) {
    let addToCart = card.querySelector(".product-add-to-cart");
    let id = card.dataset.id;
    let product = listProducts[id];
    let variant;
    let swatches = card.querySelectorAll("[data-name] .option");

    if (swatches) {
      swatches.forEach(function (swatch) {
        for (let i in product.variants) {
          variant = product.variants[i];
          if (variant.title == swatch.dataset.value) {
            if (variant.available == false) {
              swatch.classList.add("sold-out");
            } else {
              swatch.dataset.id = variant.id;
            }
          }
        }
        swatch.addEventListener("click", function () {
          for (let i in product.variants) {
            variant = product.variants[i];
            if (variant.title == swatch.dataset.value) {
              let image = card.querySelector(".product-image");
              let price = card.querySelector(".product-price");
              if (variant.featured_image?.src) {
                image.src = variant.featured_image.src;
              }

              if (swatch.classList.contains("sold-out")) {
                addToCart.innerHTML = "Sold out";
                addToCart.classList.add("sold-out");
              } else {
                addToCart.innerHTML = "Add to cart";
                addToCart.classList.remove("sold-out");
                card.querySelector("[name='product_id']").value = variant.id;
                price.innerHTML =
                  "$  " + convert_price_to_usd(variant.price, true);
              }
            }
          }
        });
      });
    }
    addToCart.addEventListener("click", function () {
      let productId = card.querySelector("[name='product_id']").value;
      add_to_cart(productId, 1);
    });
  });
  document.querySelectorAll(".custom-product").forEach(function (bundle) {
    bundle
      .querySelectorAll("[data-product-id]")
      .forEach(function (product_tab) {
        let selectors = product_tab.querySelectorAll("[data-name]");
        selectors.forEach(function (select) {
          let options = select.querySelectorAll("[data-value]");
          options.forEach(function (option) {
            option.addEventListener("click", function () {
              let option = this;
              select_option(option, select);
            });
            if (options.length == 1) {
              select_option(option, select);
            }
          });
        });
      });
  });
});

window.addEventListener("cart_changed", (e) => {
  if (e.detail.added.length != 0 || e.detail.removed.length != 0) {
    var url = "".concat("/cart.js", "?t=").concat(Date.now());
    let counter = document.querySelector(".counter-cart");

    setTimeout(() => {
      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      })
        .then((response) => response.json())
        .then((data) => {
          let totalItems = data.item_count;

          if (totalItems > 0 && counter.classList.contains("hidden")) {
            counter.classList.remove("hidden");
          }

          if (totalItems == 0) {
            counter.classList.add("hidden");
          }
          counter.innerHTML = totalItems;
        });
    }, 500);
  }
});
